import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { Button, Group } from '@mantine/core'

import { useRemoteConfig } from '../../api/RemoteConfigContext'
import { EmptyState } from '../../components/EmptyState'
import { IconSearch } from '../../components/icons'
import { ButtonLink } from '../../components/links'
import { useDocumentTitle } from '../../components/PageHeader'

/** Any address the app does not know, including an editor link to something since deleted — also the router's
 * notFoundComponent (router.tsx), so an unknown URL always lands here rather than a blank screen. */
export function NotFoundPage(props: { title?: string; body?: string }) {
  useDocumentTitle(t`Not found`)
  const { supportEmail } = useRemoteConfig()
  return (
    <EmptyState
      icon={<IconSearch size={48} />}
      title={props.title ?? t`This page doesn’t exist`}
      body={props.body ?? t`This address does not match a page. It may have moved.`}
      action={
        <Group gap="xs" justify="center">
          <ButtonLink to="/today">
            <Trans>Go to Today</Trans>
          </ButtonLink>
          <Button component="a" href={`mailto:${supportEmail}`} variant="light">
            <Trans>Help</Trans>
          </Button>
        </Group>
      }
    />
  )
}
